export default __webpack_public_path__ + "static/media/Wealth-Ultima-Brochure.68c8ef6a.pdf";